import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=0ced83e4&"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js&"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports